<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-row>
                <v-col cols="6">
                    <b-text-field
                        :label="translations.primaryEmail[lang]"
                        v-model="settings.primary_email"
                    ></b-text-field>
                </v-col>
                <v-col cols="6">
                    <b-text-field
                        :label="translations.secondaryEmail[lang]"
                        v-model="settings.secondary_email"
                    ></b-text-field>
                </v-col>
                
                <v-col cols="12">
                    <v-btn
                        color="success"
                        class="text-capitalize px-5"
                        depressed
                        v-text="translations.save[lang]"
                        @click="updateSettings"
                    ></v-btn>
                </v-col>
            </v-row>
        </v-sheet>
    </v-container>
</template>

<script>
import { mdiMagnify, mdiChevronDown } from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";
import translations from "@/utils/translations/supplierPanel/supplierDetails";

export default {
    name: "Settings",

    mixins: [translations],

    data: () => ({
        
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        settings: {
            get(){
                return this.$store.state.supplierPanel.settings;
            },
            set(val){
                this.setSettings(val)
            }
        }
    },

    methods: {
        ...mapActions("supplierPanel", ["getSettings","updateSettings"]),
        ...mapMutations("supplierPanel", ["setSettings"]),
    },
    mounted(){
        this.getSettings()
    }
};
</script>
